import { Component, Inject, OnInit, Input  } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from "@angular/forms";
import { User, Owner } from '../../../modele/user/userModel';
import {SnackbarComponent} from '../../../components/alerts/snackbar/snackbar.component';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import {BoardService} from "../../../services/board/board.service";
import {EndpointService} from "../../../services/endpoint/endpoint.service";
import {UserService} from "../../../services/user.service";
import {NGXLogger} from "ngx-logger";

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
    private log_prefix:string=this.constructor.name+":";
    board_name:string="";
    user_name:string="";
    contactFormGroup: FormGroup;
    board_id;
    email;
    username;
    getCurrentUserLiveRequest: User;

    constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private snackBar: MatSnackBar,
      private logger: NGXLogger,
      private endpointSrv: EndpointService,
      public dialogRef: MatDialogRef<DialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
      public userService: UserService
    ) {
        this.board_name = this.router.url.substr(1);

        this.userService.getUserSubject().subscribe(user => {
            this.logger.info(this.log_prefix,"got informed of user:",user.user_id);
            this.getCurrentUserLiveRequest = user;
        });

    }

    ngOnInit() {
        this.username = this.data['username']
        this.email = this.data['email']
        this.board_id = this.data['board_id']
        this.contactFormGroup = this.formBuilder.group({
            message: ['', Validators.required],
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    submit(board_id) {
      let boardInfoID = "report board:" + board_id
      this.dialogRef.close();
      this.endpointSrv.sendContactMessageToWhooosh(this.getCurrentUserLiveRequest['user_id'], this.getCurrentUserLiveRequest['user_email'], this.getCurrentUserLiveRequest['user_name'], this.contactFormGroup.value.message, boardInfoID).subscribe(data=>{
      });
      this.snackBar.openFromComponent(SnackbarComponent, {
          panelClass: "snackbar",
          duration: 1500,
          horizontalPosition: 'center',
          data: {
              message: 'keyword_$229',
              icon: 'send'
          }
      });
    }
}
